<template>
  <div style="min-width: 1100px; max-width: 1280px; margin: auto">
    <section style="padding: 40px">
      <el-row>
        <div style="width: 50%; margin: auto">
          <el-row class="title1-pur">
            <span
              ><el-image
                style="
                  width: clamp(50px, 4.5vw, 100px);
                  height: clamp(50px, 4.5vw, 100px);
                  text-align: center;
                "
                :src="url1"
                :fit="fit"
            /></span>
            <span>基础版</span>
          </el-row>
        </div>
        <div style="width: 50%; margin: auto">
          <el-row class="title1-pur">
            <span
              ><el-image
                style="
                  width: clamp(50px, 4.5vw, 100px);
                  height: clamp(50px, 4.5vw, 100px);
                  text-align: center;
                "
                :src="url1"
                :fit="fit"
            /></span>
            <span>专业版</span>
          </el-row>
        </div>
      </el-row>
      <el-row>
        <div style="width: 45%; margin: auto">
          <div style="width: 50%; margin: auto">
            <div class="purtextstyle2">包含以下模块</div>
            <div class="purtextstyle3"><li>装配式单梁模块</li></div>
            <div class="purtextstyle3"><li>装配式梁格模块</li></div>
            <div class="purtextstyle3"><li>装配式桥墩模块</li></div>
          </div>
        </div>
        <div style="width: 10%; margin: auto">
          <el-divider direction="vertical" style="height:200px" />
        </div>
        <div style="width: 45%; margin:auto;">
          <div class="purtextstyle2">包含以下模块</div>
          <el-row>
            <div style="width: 60%; ">
              <div class="purtextstyle3"><li>装配式单梁模块</li></div>
              <div class="purtextstyle3"><li>装配式梁格模块</li></div>
              <div class="purtextstyle3"><li>装配式桥墩模块</li></div>
            </div>
            <div style="width: 40%; ">
              <div class="purtextstyle3"><li>等高现浇箱梁模块</li></div>
              <div class="purtextstyle3"><li>变高现浇箱梁模块</li></div>
              <div class="purtextstyle3"><li>悬浇现浇箱梁模块</li></div>
              <div class="purtextstyle3"><li>裤衩现浇箱梁模块</li></div>
            </div>
          </el-row>
        </div></el-row
      >
      <el-row style="padding-top: 40px;">
        <div style="width: 50%; margin: auto">
          <div class="purtextstyle1">¥ 200元 / 年</div>
        </div>
        <div style="width: 50%; margin: auto">
          <div class="purtextstyle1">¥ 500元 / 年</div>
        </div>
      </el-row>
    </section>
    <el-divider></el-divider>
    <section style="padding: 30px">
      <el-row style="height: 200px">
        <el-col :span="1"></el-col>
        <el-col :span="10">
          <div style="font-size: 18px; font-weight: 600">付款方式</div>
          <div style="height: 120px; padding-top: 20px">
            <el-image
              style="width: 100px; height: 100px"
              :src="url2"
              :fit="fit"
            />
          </div>
          <div style="height: 40px; padding-top: 20px">
            微信公众号 <el-icon><Right /></el-icon>我的服务
            <el-icon><Right /></el-icon>个人中心
            <el-icon><Right /></el-icon>充值缴费
          </div>
          <div style="height: 40px; padding-top: 20px">
          公司一次购买多个账号有相应折扣，联系邮箱：weiao@weiao.tech
          </div>
        </el-col>
        <el-col :span="2"></el-col>
        <el-col :span="10">
          <div style="font-size: 18px; font-weight: 600;">电子发票开具</div>
          <div style="height: 40px; padding-top: 30px">
            微信公众号 <el-icon><Right /></el-icon>我的服务
            <el-icon><Right /></el-icon>个人中心，登记QQ号码
          </div>
          <div style="height: 40px; padding-top: 20px">
            缴费后申请加入QQ群：786501002（备注“缴费用户”）
          </div>
          <div style="height: 40px; padding-top: 20px">
            与技术支持联系后开具正规电子发票
          </div>
        </el-col>
      </el-row>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      url1: require("@/assets/png/modelhelper.png"),
      url2: require("@/assets/png/install-1.jpg"),
      fit: "fill",
    };
  },
};
</script>
<style>
.title1-pur {
  font-size: clamp(24px, 1.6vw, 55px);
  font-weight: 800;
  color: rgb(50, 90, 170);
  text-align: center;
  line-height: 1.5；;
  padding: 60px;
  align-items: center;
  justify-content: center;
}
.purtitle {
  display: flex;
  justify-content: center;
  align-items: center;
}
.purtextstyle1 {
  font-family: Arial;
  height: 60px;
  padding-top: 30px;
  font-size: 40px;
  font-weight: 800;
  color: rgb(50, 90, 170);
}
.purtextstyle2 {
  text-align: left;
  font-family: Arial;
  height: 40px;
  padding-top: 15px;
  padding-bottom: 15px;
  font-size: 24px;
  font-weight: 800;
  color: rgb(50, 90, 170);
}
.purtextstyle3 {
  text-align: left;
  font-family: Arial;
  height: 24px;
  padding: 6px;
  font-size: 18px;
  font-weight: 800;
  color: rgb(50, 90, 170);
}
</style>
